var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2058 25.0002C48.2058 23.288 48.0521 21.6417 47.7668 20.0612H25.0253V29.4015H38.0204C37.4606 32.4198 35.7594 34.9771 33.2021 36.6893V42.7478H41.0058C45.5716 38.5442 48.2058 32.3539 48.2058 25.0002Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.025 48.5975C31.5445 48.5975 37.0103 46.4353 41.0055 42.7475L33.2018 36.6889C31.0396 38.1377 28.2738 38.9938 25.025 38.9938C18.7359 38.9938 13.4128 34.7463 11.514 29.0389H3.4469V35.295C7.42007 43.1865 15.5859 48.5975 25.025 48.5975Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5143 29.0396C11.0314 27.5908 10.757 26.0433 10.757 24.4518C10.757 22.8603 11.0314 21.3128 11.5143 19.864V13.6079H3.4472C1.81183 16.8676 0.878906 20.5554 0.878906 24.4518C0.878906 28.3481 1.81183 32.0359 3.4472 35.2957L11.5143 29.0396Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.025 9.90884C28.5701 9.90884 31.753 11.1271 34.2555 13.5198L41.1811 6.59421C36.9994 2.69786 31.5335 0.305176 25.025 0.305176C15.5859 0.305176 7.42007 5.71616 3.4469 13.6076L11.514 19.8637C13.4128 14.1564 18.7359 9.90884 25.025 9.90884Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo_google.ef8ee85046ca818c8f33472856d63281.svg";
export { ForwardRef as ReactComponent };